import {Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {GeocodingService} from '@services/administration/machine/geocoding/geocoding.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {WidgetHelperService} from '@services/pages/widget/widget-helper.service';
import {GoogleMap, MapInfoWindow, MapMarker} from '@angular/google-maps';
import {Machine} from '@models/machine/machine';
import {GOOGLE_MAPS_DIRECTION_URL} from '@constants/google-maps/google-maps.constant';

@Component({
    selector: 'scitis-map-content',
    templateUrl: './map-content.component.html',
    styleUrls: ['./map-content.component.scss'],
    standalone: false
})
export class MapContentComponent implements OnInit, OnChanges {

  // decorators
  @ViewChild('googleMap')
  map: GoogleMap | undefined;
  @Input()
  zoomLvl: number = 0;
  @Input()
  machine: Machine = new Machine();
  @Input()
  mapType: google.maps.MapTypeId | undefined;

  // public
  public googleMapsLoaded: boolean = false;
  public mapOptions!: google.maps.MapOptions;
  public marker!: google.maps.Marker;

  //private
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private geocodingService: GeocodingService,
    private widgetService: WidgetHelperService,
  ) {}

  ngOnInit(): void {
    this.initMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mapType && !changes.mapType.firstChange && this.map) {
      this.marker.set('options', this.widgetService.setMarkerOptions(this.mapType));
    }
  }

  //public methods
  public onOpenInfoWindow(mapMarker: MapMarker, infoWindow: MapInfoWindow): void {
    infoWindow.open(mapMarker);
  }

  public onCloseInfoWindow(): void {
    if (this.map) {
      this.map.panTo(this.marker.getPosition() as google.maps.LatLng);
    }
  }

  public machineAddress(): string {
    return this.widgetService.getMachineAddress(this.machine.locationDetails);
  }

  public redirectToGoogleMaps(): void {
    const {lat, lng} = this.marker.getPosition() as google.maps.LatLng;
    const url = GOOGLE_MAPS_DIRECTION_URL + `${lat()},${lng()}`;
    window.open(url, '_blank');
  }

  // private methods
  private initMap(): void {
    this.geocodingService.loadMapsApiObservable().pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.googleMapsLoaded = true;
        let position: google.maps.LatLng | undefined;
        if (this.machine.locationDetails.latitude && this.machine.locationDetails.longitude) {
          const {longitude, latitude} = this.machine.locationDetails;
          position = new google.maps.LatLng(latitude, longitude);
        }
        this.marker = this.widgetService.markerInit(position, this.machine.type);
        this.marker.set('options', this.widgetService.setMarkerOptions(this.mapType));
        this.mapOptions = this.widgetService.mapOptionsInit(position);
        this.mapOptions.zoomControl = false;
      });
  }
}
